// extracted by mini-css-extract-plugin
export default {"modal":"ResendInviteModal__modal___vctxZ"};